import React from "react";
import {connect} from "react-redux";
import Images from "./blockLoop/Images";
import People from "./blockLoop/People";
import SideList from "./blockLoop/SideList";

class SideLoop extends React.Component {

    render() {

        return (
          <div className="rob-sideloop">

              {this.props.blockLoop.map(function (name, index) {
                  switch(name.type){
                      case 'images':
                          return  <Images key={index} {...name} />;
                      default:
                          return null;
                  }
              })
              }

              {this.props.blockLoop.map(function (name, index) {

                  switch(name.type){
                      case 'people':
                          return  <People key={index} {...name} />;
                      default:
                          return null;
                  }

              })
              }

              {this.props.blockLoop.map(function (name, index) {

                  switch(name.type){
                      case 'articles':
                          return  <SideList key={index} {...name} />;
                      default:
                          return null;
                  }

              })
              }




          </div>
        )
    }
}
SideLoop.defaultProps = {blockLoop: []};


function mapStateToProps(state) {
    return {
        blockLoop: state.page.blockLoop,
    };
}

export default connect(mapStateToProps)(SideLoop);




// WEBPACK FOOTER //
// ./src/components/elements/SideLoop.js